import classie from 'classie';

import Barba from 'barba.js';

import gsap from 'gsap';

import BezierEasing from 'bezier-easing';

import { qsa, qs, byId, toggleClass } from './dom-utils';

const $transition = byId('page-transition');
const $transitionStripes = qsa('.c-transition__stripe', $transition);

//const pageTransitionEase = BezierEasing(0.81, 0.12, 0.48, 0.98);
const pageTransitionEase = BezierEasing(0.94, 0.13, 0.34, 0.99);
const articleTransitionEase = BezierEasing(0.61, 0.01, 0.08, 0.99);

export const PageTransition = Barba.BaseTransition.extend({

    start: function() {
        /**
         * This function is automatically called as soon the Transition starts
         * this.newContainerLoading is a Promise for the loading of the new container
         * (Barba.js also comes with an handy Promise polyfill!)
         */

        // As soon the loading is finished and the old page is faded out, let's fade the new page
        Promise
            .all([this.newContainerLoading, this.fadeOut()])
            .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {
        /**
         * this.oldContainer is the HTMLElement of the old Container
         */

        return new Promise((resolve, reject) => {

            const fadeOut = new TimelineLite({
                onComplete: () => {
                    Barba.Dispatcher.trigger('newPageReset');
                    setTimeout(resolve, 1500)
                }
            });

            fadeOut.add(() => classie.add($transition, 'is-visible'))

            fadeOut.set($transitionStripes, {
                transformOrigin: '0 0'
            })

            fadeOut.to($transitionStripes, 1, {
                scaleX: 1,
                force3D: false,
                ease: new Ease(pageTransitionEase)
            });

        });

    },

    fadeIn: function() {
        /**
         * this.newContainer is the HTMLElement of the new Container
         * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
         * Please note, newContainer is available just after newContainerLoading is resolved!
         */

        Barba.Dispatcher.trigger('newPageDidMount');

        const fadeIn = new TimelineLite({
            onStart: this.done.bind(this),
            onComplete: () => {
                toggleClass($transition, 'is-visible', false);
                Barba.Dispatcher.trigger('pageEnteredCompletely', Barba.HistoryManager.currentStatus().namespace);
            }
        });

        fadeIn.set($transitionStripes, {
            transformOrigin: '100% 0'
        })

        fadeIn.staggerTo($transitionStripes, 0.7, {
            scaleX: 0,
            force3D: false,
            ease: Power2.easeInOut
        }, 0.05);
    }

});

export const PageToArticle = Barba.BaseTransition.extend({

    start: function() {
        /**
         * This function is automatically called as soon the Transition starts
         * this.newContainerLoading is a Promise for the loading of the new container
         * (Barba.js also comes with an handy Promise polyfill!)
         */

        // As soon the loading is finished and the old page is faded out, let's fade the new page
        Promise
            .all([this.newContainerLoading, this.fadeOut()])
            .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {
        /**
         * this.oldContainer is the HTMLElement of the old Container
         */

        return new Promise((resolve, reject) => {

            const fadeOut = new TimelineLite({
                onComplete: () => {
                    Barba.Dispatcher.trigger('newPageReset');
                    resolve();
                }
            });

            fadeOut.to(this.oldContainer, 0.5, {
                opacity: 0,
                ease: Linear.easeNone
            });

        });

    },

    fadeIn: function() {
        /**
         * this.newContainer is the HTMLElement of the new Container
         * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
         * Please note, newContainer is available just after newContainerLoading is resolved!
         */

        Barba.Dispatcher.trigger('newPageDidMount');

        const fadeIn = new TimelineMax({
            onStart: this.done.bind(this),
            onComplete: () => Barba.Dispatcher.trigger('pageEnteredCompletely', Barba.HistoryManager.currentStatus().namespace)
        });

        const $article = byId('single-post');

        fadeIn.set($article, {
            xPercent: 100
        })

        .to($article, 0.85, {
            xPercent: 0,
            ease: new Ease(articleTransitionEase)
        });
    }

});

export const ArticleToPage = Barba.BaseTransition.extend({

    start: function() {
        /**
         * This function is automatically called as soon the Transition starts
         * this.newContainerLoading is a Promise for the loading of the new container
         * (Barba.js also comes with an handy Promise polyfill!)
         */

        // As soon the loading is finished and the old page is faded out, let's fade the new page
        Promise
            .all([this.newContainerLoading, this.fadeOut()])
            .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {
        /**
         * this.oldContainer is the HTMLElement of the old Container
         */

        return new Promise((resolve, reject) => {

            const fadeOut = new TimelineLite({
                onComplete: () => {
                    Barba.Dispatcher.trigger('newPageReset');
                    resolve();
                }
            });

            const $article = qs('#single-post', this.oldContainer);


            if ($article) {

                fadeOut.to($article, 0.85, {
                    xPercent: 100,
                    ease: new Ease(articleTransitionEase)
                });
            }

        });

    },

    fadeIn: function() {
        /**
         * this.newContainer is the HTMLElement of the new Container
         * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
         * Please note, newContainer is available just after newContainerLoading is resolved!
         */


        Barba.Dispatcher.trigger('newPageDidMount');

        const fadeIn = new TimelineMax({
            onStart: this.done.bind(this),
            onComplete: () => Barba.Dispatcher.trigger('pageEnteredCompletely', Barba.HistoryManager.currentStatus().namespace)
        });

        fadeIn.set(this.newContainer, {
            autoAlpha: 0
        })

        .to(this.newContainer, 0.5, {
            autoAlpha: 1,
            ease: new Ease(articleTransitionEase)
        });
    }

});


/** WEBPACK FOOTER **
 ** ./base/page-transition.js
 **/